/**
 * @generated SignedSource<<fcf4b2c3b953d3c6d00bc8c0187729e9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type AccountStatus = "active" | "closed" | "inactive" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type creator_AtlassianConversationAssistantAgent_AgentCreatorDataComponent$data = {
  readonly authoringTeam: {
    readonly displayName: string | null;
    readonly profileUrl: string | null;
  } | null;
  readonly creator: {
    readonly accountId: string;
    readonly accountStatus?: AccountStatus;
    readonly name: string;
  } | null;
  readonly creatorType: string | null;
  readonly forgeCreator: string | null;
  readonly " $fragmentType": "creator_AtlassianConversationAssistantAgent_AgentCreatorDataComponent";
};
export type creator_AtlassianConversationAssistantAgent_AgentCreatorDataComponent$key = {
  readonly " $data"?: creator_AtlassianConversationAssistantAgent_AgentCreatorDataComponent$data;
  readonly " $fragmentSpreads": FragmentRefs<"creator_AtlassianConversationAssistantAgent_AgentCreatorDataComponent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "creator_AtlassianConversationAssistantAgent_AgentCreatorDataComponent",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "creatorType"
    },
    {
      "kind": "LinkedField",
      "name": "creator",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "accountId"
        },
        {
          "kind": "ScalarField",
          "name": "name"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "accountStatus"
            }
          ],
          "type": "AtlassianAccountUser"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "forgeCreator"
    },
    {
      "concreteType": "TeamV2",
      "kind": "LinkedField",
      "name": "authoringTeam",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "displayName"
        },
        {
          "kind": "ScalarField",
          "name": "profileUrl"
        }
      ]
    }
  ],
  "type": "AgentStudioAssistant"
};

(node as any).hash = "c69f2315be4a93e220d4c24987745ff2";

export default node;
